import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { useNotification } from '../context/NotificationContext'; // Import Global Notification

const Register = () => {
  const navigate = useNavigate();
  const { notify } = useNotification(); // Initialize the hook
  
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    role: 2, // Default to Company (2)
    industry: 'commercial-cleaning' // Default industry for companies
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.post('auth/register/', formData);
      
      // Success Notification
      notify('success', 'Account created successfully! Please log in.');
      
      // Redirect to Login
      navigate('/login');
    } catch (err) {
      console.error(err);
      // Error Notification
      const message = err.response?.data?.username 
        ? "Username already taken." 
        : "Registration failed. Please check your details.";
      notify('error', message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-light py-12 px-4 sm:px-6 lg:px-8 font-[Poppins]">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg border border-gray-100">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Create Account
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Join the RevenueSetters Marketplace
          </p>
        </div>

        {/* Removed local error div - Notifications handle this now */}

        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          
          {/* Role Selection Tabs */}
          <div className="flex bg-gray-100 p-1 rounded-lg mb-6">
            <button
              type="button"
              onClick={() => setFormData({...formData, role: 2})}
              className={`flex-1 py-2 text-sm font-medium rounded-md transition-all ${
                formData.role === 2 ? 'bg-white text-primary shadow-sm font-bold' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              I'm a Company
            </button>
            <button
              type="button"
              onClick={() => setFormData({...formData, role: 3})}
              className={`flex-1 py-2 text-sm font-medium rounded-md transition-all ${
                formData.role === 3 ? 'bg-white text-primary shadow-sm font-bold' : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              I'm a Setter
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Username</label>
              <input
                type="text"
                required
                className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-primary focus:border-primary sm:text-sm transition-colors"
                placeholder="Choose a username"
                value={formData.username}
                onChange={(e) => setFormData({...formData, username: e.target.value})}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">Email Address</label>
              <input
                type="email"
                required
                className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-primary focus:border-primary sm:text-sm transition-colors"
                placeholder="name@company.com"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
              />
            </div>

            {/* Industry Selection (Only for Company) */}
            {formData.role === 2 && (
              <div>
                <label className="block text-sm font-medium text-gray-700">Industry Interest</label>
                <select
                  className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-primary focus:border-primary sm:text-sm bg-white"
                  value={formData.industry}
                  onChange={(e) => setFormData({...formData, industry: e.target.value})}
                >
                  <option value="commercial-cleaning">Commercial Cleaning</option>
                  <option value="janitorial">Janitorial Services</option>
                  <option value="real-estate">Real Estate</option>
                  <option value="financial">Financial Services</option>
                  <option value="healthcare">Healthcare</option>
                  <option value="technology">Technology</option>
                  <option value="mca">MCA</option>
                </select>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700">Password</label>
              <input
                type="password"
                required
                className="mt-1 block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-primary focus:border-primary sm:text-sm transition-colors"
                placeholder="Create a strong password"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-bold rounded-lg text-white bg-primary hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary transition-all shadow-md hover:shadow-lg transform active:scale-95"
          >
            Create Account
          </button>
        </form>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            Already have an account?{' '}
            <Link to="/login" className="font-bold text-primary hover:text-blue-500 hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;